/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/heading-has-content */
import React, {useState} from "react";
import LoadingBar from "react-top-loading-bar";
import "react-toastify/dist/ReactToastify.css";
import "./Layout.scss";
import "./../Modal/Modal.scss";
import Login from "@containers/Login";
import androidQrCode from "@images/android-qrcode.png";
import iosQrCode from "@images/ios-qrcode.png";
import Container from "react-bootstrap/Container";
import {routeCodes} from "@constants/routes";
import {useAuth} from "@context/Auth";
import AlertModal from "@adoo-ui/Molecule/AlertModal";
import {usePlanoAlertaModal} from "@context/PlanoAlertaModal";
import {useLoadingBar} from "@context/LoadingBar";
import Header from "@adoo-ui/Organism/Header";
import Footer from "@adoo-ui/Organism/Footer";
import {useHistory} from "react-router-dom";
import createMensagemContato from "@api/requests/suporte/createMensagemContato";

// @TODO: move to containers
function Layout({children, showContactForm = true, isBlackFriday = false}) {
  const {currentProgress, setCurrentProgress} = useLoadingBar();
  const {isVisible, closeAlert, getMessage, goBackOnClose} = usePlanoAlertaModal();

  const history = useHistory();

  const {currentUser, isAuthenticated, logout} = useAuth();
  const [isLoginFormVisible, setIsLoginFormVisible] = useState(false);

  const onSuccessLogin = () => {
    setIsLoginFormVisible(false);

    if (history && history.location.pathname === routeCodes.HOME) {
      history.push("/navegacao");
    } else {
      window.location.reload();
    }
  };

  const getIsDiarioOficialRoute = () => {
    const rotasMenuDiarioOficial = [
      routeCodes.NAVEGACAO,
      routeCodes.ALERTAS,
      routeCodes.SEARCH,
      routeCodes.VIEWER,
    ];

    let pathname = history.location.pathname.split("/")[1];
    let rotaPai = `/${pathname}`;
    if (rotasMenuDiarioOficial.includes(rotaPai)) {
      return true;
    }
    return false;
  };

  const getIsConsultaProcessual = () => {
    let pathname = history.location.pathname.split("/")[1];
    if (pathname.includes("consulta-processual")) {
      return true;
    }
    return false;
  };

  return (
    <div>
      <LoadingBar
        height={3}
        color="#6034c7"
        progress={currentProgress}
        onLoaderFinished={() => setCurrentProgress(0)}
      />
      {/* <div class="overlay">
        <div class="overlay__inner">
          <div class="overlay__content">
            <span class="spinner"></span>
          </div>
        </div>
      </div> */}
      <AlertModal
        show={isVisible}
        config={getMessage()}
        onHide={() => {
          closeAlert();
          if (goBackOnClose) window.history.back();
        }}
      />

      <div>
        <Login
          show={isLoginFormVisible}
          onSuccessLogin={onSuccessLogin}
          onHide={({action}) => {
            setIsLoginFormVisible(false);
          }}
        />
      </div>
      <div className="modal micromodal-slide" id="modal-android" aria-hidden="true">
        <div className="modal__overlay" tabIndex="-1" data-micromodal-close>
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-android-title"
          >
            <div className="modal__header">
              <h2 className="modal__title" id="modal-android-title"></h2>
              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </div>
            <div className="modal__content" id="modal-android-content">
              <div id="qrcode-android-content">
                <h5>
                  Aponte seu leitor de QRCODE para baixar na{" "}
                  <a
                    href="https://play.google.com/store/apps/details?id=com.adoo.app"
                    title="Baixar na Google Play"
                  >
                    Play Store
                  </a>
                </h5>
                <div className="img-wrapper">
                  <img src={androidQrCode} alt="Baixar na Google Play" target="_blank" />
                </div>
              </div>
            </div>
            <div className="modal__footer">
              <a
                href="https://play.google.com/store/apps/details?id=com.adoo.app"
                title="Baixar na Google Play"
                className="modal__btn modal__btn-primary"
              >
                Baixar na Play Store
              </a>
              <a
                href="/navegacao"
                title="Versão web"
                className="modal__btn modal__btn-primary"
              >
                Versão web
              </a>
              <button
                className="modal__btn"
                data-micromodal-close
                aria-label="Close this dialog window"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal micromodal-slide" id="modal-ios" aria-hidden="true">
        <div className="modal__overlay" tabIndex="-1" data-micromodal-close>
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-ios-title"
          >
            <div className="modal__header">
              <h2 className="modal__title" id="modal-ios-title"></h2>
              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </div>
            <div className="modal__content" id="modal-ios-content">
              <div id="qrcode-android-content">
                <h5>
                  Aponte seu leitor de QRCODE para baixar na{" "}
                  <a
                    href="https://apps.apple.com/br/app/adoo/id1529677418"
                    title="Baixar na App Store"
                  >
                    App Store
                  </a>
                </h5>
                <div className="img-wrapper">
                  <img src={iosQrCode} alt="Baixar na App Store" target="_blank" />
                </div>
              </div>
            </div>
            <div className="modal__footer">
              <a
                href="https://apps.apple.com/br/app/adoo/id1529677418"
                title="Baixar na App Store"
                className="modal__btn modal__btn-primary"
              >
                Baixar na App Store
              </a>
              <a
                href="/navegacao"
                title="Versão web"
                className="modal__btn modal__btn-primary"
              >
                Versão web
              </a>
              <button
                className="modal__btn"
                data-micromodal-close
                aria-label="Close this dialog window"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <Header
        isAuthenticated={isAuthenticated}
        routeCodes={routeCodes}
        setIsLoginFormVisible={setIsLoginFormVisible}
        currentUser={currentUser()}
        logout={logout}
        isDiarioOficialRoute={getIsDiarioOficialRoute()}
        isConsultaProcessual={getIsConsultaProcessual()}
      />
      <div style={{clear: "both", height: 80}}></div>
      <Container fluid className="no-padding">
        {children}
      </Container>
      <Footer
        showContactForm={showContactForm}
        onFormSubmit={createMensagemContato}
        enableRecaptcha={true}
        isBlackFriday={isBlackFriday}
      />
    </div>
  );
}

export default Layout;
